module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var bundleLocked = false;
if(typeof contentLocked !== 'undefined' && contentLocked == true){
    bundleLocked = true;
}

    ; __append("\n\n<article class=\"show-browse-item\">\n    <a class=\"focusable\" href=\"")
    ; __append(escapeFn( href ))
    ; __append("\" aa-link=\"")
    ; __append(escapeFn( aaLink ))
    ; __append("\">\n        <div class=\"thumb-wrapper\">\n          ")
    ;  if(typeof thumb !== 'undefined'){ 
    ; __append("\n            <img class=\"thumb lazy\" src=\"data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=\" data-src=\"")
    ; __append(escapeFn( thumb || '' ))
    ; __append("\" alt=\"")
    ; __append(escapeFn( title ))
    ; __append("\" />\n          ")
    ;  } 
    ; __append("\n          ")
    ;  if(bundleLocked && CBS.Registry.user_auth) { 
    ; __append("\n            <div class=\"bundle-lock-gradient\"></div>\n            <div class=\"label bundle-lock portrait\"><img src=\"/assets/images/svg/content_lock.svg\"/></div>\n          ")
    ;  } 
    ; __append("\n        </div>\n    </a>\n\n    ")
    ;  if(CBS.Registry.brand.name !== 'PPLUS') { 
    ; __append("\n    <div class=\"info-wrapper\">\n        <div class=\"title-wrapper\">\n            <span class=\"title\">\n                <a href=\"")
    ; __append(escapeFn( href ))
    ; __append("\" aa-link=\"")
    ; __append(escapeFn( aaLink ))
    ; __append("\" tabindex=\"-1\">")
    ; __append(escapeFn( title ))
    ; __append("</a>\n            </span>\n        </div>\n    </div>\n    ")
    ;  } 
    ; __append("\n</article>\n")
  }
  return __output;

}